export const defaultGtm = () => ({
	statusFilter: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Abir etapa em nova aba',
	},
})
